import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("token"); // Check for token

  if (!token) {
    return <Navigate to="/login" />; // Redirect to login if token is missing
  }

  return children; // Allow access if a token exists
};

export default ProtectedRoute;